import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.text,
        color: Colors.warning
      }
    }
  )
}
function renderSupportButton(h) {
  return h(
    button,
    {
      props: {
        iconSVG: 'question',
        tooltip: this.getTranslate('misc.buttons.support'),
        mode: buttonModes.flat,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.$router.push({ name: 'support' })
        }
      }
    }
  )
}

export default function(h) {
  if (this.show) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__warning`
      },
      [
        renderWarning.call(this, h),
        renderSupportButton.call(this, h)
      ]
    )
  }
}
